import { render, staticRenderFns } from "./SelectedFiles.vue?vue&type=template&id=e6bfabc8"
import script from "./SelectedFiles.vue?vue&type=script&lang=js"
export * from "./SelectedFiles.vue?vue&type=script&lang=js"
import style0 from "./SelectedFiles.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports